module.exports = __webpack_public_path__ + "static/assets/28e1bf90dd4397961020a9b36131227b.svg";